<template>
    <v-flex d-block xs12>
        <v-card>
            <v-card-text>
                <v-layout>
                    <v-flex xs12 md3>
                        <v-select :items="availableCaseCreationOrderStatuses"
                                  v-model="caseCreationOrderFiltersStatuses"
                                  :label="$t('caseCreationOrders.filters.statuses.label')"
                                  multiple
                                  itemm-value="value"
                                  item-text="title"
                                  persistent-hint
                                  chips></v-select>
                    </v-flex>

                    <v-flex xs12 md6 class="ml-3">
                        {{$t('caseCreationOrders.filters.creationDatetime.label')}}:
                        <v-menu full-width offset-y :close-on-content-click="false" v-model="filterCaseCreationOrderDateRangeMenuVisible" bottom>
                            <v-btn color="primary" outline slot="activator">{{ caseCreationOrders.filters.createdFrom }} &mdash; {{ caseCreationOrders.filters.createdTo }}</v-btn>
                            <v-card>
                                <v-card-text>
                                    <v-daterange :options="caseCreationOrders.creationDateRangeFilterOptions"
                                                 :labels="{
                                                    start: $t('caseCreationOrders.filters.creationDatetime.start.label'),
                                                    end: $t('caseCreationOrders.filters.creationDatetime.end.label')
                                                 }"
                                                 @input="handleFilterUpdateCreationDatetime"
                                                 no-presets/>
                                </v-card-text>
                            </v-card>
                        </v-menu>
                    </v-flex>
                </v-layout>
                <v-layout v-bind:style="{'display': 'inline-block', 'width': '100%'}">
                    <v-data-table
                            :headers="headers"
                            :items="caseCreationOrders.items"
                            :pagination.sync="caseCreationOrders.pagination"
                            :total-items="caseCreationOrders.totalItems"
                            :loading="caseCreationOrders.loading"
                            :rows-per-page-items="[10, 25, 40]"
                            :no-data-text="$t('cases.table.noResultText')"
                            :rows-per-page-text="$t('cases.table.itemsPerPage')"
                            class="elevation-1 cases-wide"
                    >
                        <template slot="items" slot-scope="props">
                            <tr @click="handleCaseCreationOrderClickHandler(props.item.id)" :style="{'cursor': 'pointer'}" >
                                <td>{{ props.item.id }}</td>
                                <td>{{ props.item.createdAt | DateWithMinutes }}</td>
                                <td>{{ props.item.caseTitle | NoEmpty }}</td>
                                <td>{{ extractFieldFromData(props.item, 'patientName') }}</td>
                                <td>{{ specialistName(props.item.userId) }}</td>
                                <td>{{ statusTitle(props.item.status) }}</td>
                                <td @click.stop>
                                    <v-btn
                                            small
                                            outline
                                            color="primary"
                                            :disabled="!isBlankAvailable(props.item)"
                                            :loading="!!blankLoadingById[props.item.id]"
                                            @click.stop="handleBlankClick(props.item)"
                                    >{{ $t('caseCreationOrders.table.blank.button') }}</v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>

  import _ from 'lodash'
  import { mapActions, mapState } from 'vuex'
  import NoEmpty from '../Filters/NoEmpty.js'
  import DateWithMinutes from '../Filters/DateWithMinutes.js'
  import api from '@/api'

  export default {
    name: "CreationOrders",
    filters: {
      DateWithMinutes,
      NoEmpty
    },
    data() {
      return {
        filterCaseCreationOrderDateRangeMenuVisible: false,
        blankLoadingById: {},
        headers: [
          {
            text: this.$t('caseCreationOrders.table.columns.header.id'),
            align: 'left',
            sortable: false,
            value: 'id',
            width: '100px'
          },
          {
            text: this.$t('caseCreationOrders.table.columns.header.createdAt'),
            align: 'left',
            sortable: false,
            value: 'createdAt',
            width: '170px'
          },
          {
            text: this.$t('caseCreationOrders.table.columns.header.caseTitle'),
            align: 'left',
            sortable: false,
            value: 'caseTitle',
            width: '170px'
          },
          {
            text: this.$t('caseCreationOrders.table.columns.header.patientName'),
            align: 'left',
            sortable: false,
            value: 'patientName',
            width: '250px'
          },
          {
            text: this.$t('caseCreationOrders.table.columns.header.specialist'),
            align: 'left',
            sortable: false,
            value: 'specialistName',
            width: '250px'
          },
          {
            text: this.$t('caseCreationOrders.table.columns.header.status'),
            align: 'left',
            sortable: false,
            value: 'status',
            width: '150px'
          },
          {
            text: this.$t('caseCreationOrders.table.columns.header.blank'),
            align: 'left',
            sortable: false,
            value: 'blank',
            width: '120px'
          }
        ]
      }
    },
    created () {
      this.caseCreationOrdersLoad()
    },
    watch: {
      pagination: {
        async handler () {
          this.caseCreationOrdersLoad()
        },
        deep: true
      }
    },
    computed: {
      ...mapState({
        availableCaseCreationOrderStatuses: 'availableCaseCreationOrderStatuses',
        availableCaseCreationOrderStatusesByValue: 'availableCaseCreationOrderStatusesByValue',
        caseCreationOrders: 'caseCreationOrders',
        currentClient: 'currentClient',
        availableUsersById: 'availableUsersById',
        pagination: state => state.caseCreationOrders.pagination
      }),
      caseCreationOrderFiltersStatuses: {
        get () {
          return this.caseCreationOrders.filters.statuses
        },
        set (values) {
          this.caseCreationOrdersChangeFilterStatuses(values)
        }
      },
    },
    methods: {
      ...mapActions({
        caseCreationOrdersChangeFilterStatuses: 'caseCreationOrdersChangeFilterStatuses',
        caseCreationOrdersChangeFilterDates: 'caseCreationOrdersChangeFilterDates',
        caseCreationOrdersLoad: 'caseCreationOrdersLoad'
      }),
      handleFilterUpdateCreationDatetime: _.debounce(function(range) {
        this.caseCreationOrdersChangeFilterDates({
          createdFrom: range[0],
          createdTo: range[1]
        })
      }, 200),
      extractFieldFromData(item, path) {
        return _.get(item.data, path, '-')
      },
      statusTitle(status) {
        return _.get(this.availableCaseCreationOrderStatusesByValue, [status, 'title'], '-')
      },
      specialistName(userId) {
        return _.get(this.availableUsersById, [userId, 'name'], '-')
      },
      handleCaseCreationOrderClickHandler (orderId) {
        this.$router.push({
          name: 'updateCaseCreationOrder',
          params: {
            id: orderId
          }
        })
      },
      isBlankAvailable (item) {
        return item.status === 'waitingForMaterials'
      },
      async handleBlankClick (item) {
        if (!this.isBlankAvailable(item)) {
          return
        }

        const previewWindow = window.open('', '_blank')
        this.$set(this.blankLoadingById, item.id, true)
        try {
          const reportData = await api.getCaseCreationOrderBlank(item.id)
          const blob = new Blob([reportData], { type: 'application/pdf' })
          const url = URL.createObjectURL(blob)
          if (previewWindow) {
            previewWindow.location = url
          } else {
            window.open(url, '_blank')
          }
        } catch (e) {
          if (previewWindow) {
            previewWindow.close()
          }
          this.$snotify.error(this.$t('caseCreationOrders.messages.unableToGenerateBlank'))
        }
        this.$set(this.blankLoadingById, item.id, false)
      }
    },
  }
</script>

<style scoped>

</style>